export const DEFAULT_DARK_THEME_CLASS_NAME = 'theme--dark';
export const DEFAULT_LIGHT_THEME_CLASS_NAME = 'theme--light';
export const LIGHT_THEME_STORAGE_KEY = 'ui.isLightTheme';

/**
 * Applies or removes the light theme class to the body
 * @param isLightTheme if light theme should be applied
 * @param savePreference whether to save the preference to local storage
 */
export function applyTheme(isLightTheme: boolean, savePreference = false): void {
  // We need one of the classes to be always present to for proper custom CSS vars application
  window.document.body.classList.toggle(DEFAULT_DARK_THEME_CLASS_NAME, !isLightTheme);
  window.document.body.classList.toggle(DEFAULT_LIGHT_THEME_CLASS_NAME, isLightTheme);
  if (savePreference) {
    window.localStorage.setItem(LIGHT_THEME_STORAGE_KEY, isLightTheme.toString());
  }
}
